import { fetchSecureData } from "../utils";

export const removeKpi = async (accessToken: string, id: number) => {
  try {
    const data = await fetchSecureData(
      "DELETE",
      `/api/Kpi/Remove?id=${id}`,
      accessToken
    );
    const result = await data.json();
    return result.statusCode;
  } catch (err) {
    // tslint:disable-next-line:no-console
    console.log(`Fetch error for /api/Kpi/Remove?id=${id}`, err);
  }
  return 404;
};

export default removeKpi;
